type SecuredCreditCardParams = {
  number: string
  length?: number
}

// number example = 'XXXX1213' getting from backend transform to "**** **** **** 1213"
export const getSecuredCreditCardNumber = ({
  number,
  length = 19,
}: SecuredCreditCardParams): string => {
  return number.slice(-4).padStart(length, '**** ')
}
